<template>
  <div class="consumer-dashboard">
    <HeaderSection :user="user" />
    <div class="dashboard-grid">
      <SidebarSection :user="user" />
      <main class="main-content">
        <LiveChallengeBanner />
        <PillarSection
          pillar="apprentissage"
          :header="pillarHeaders[0]"
          :completion="'3/5 modules complétés'"
          :cards="pillar1Cards"
        />
        <PillarSection
          pillar="validation"
          :header="pillarHeaders[1]"
          :completion="'2 badges Bronze obtenus'"
          :cards="pillar2Cards"
        />
        <PillarSection
          pillar="defis"
          :header="pillarHeaders[2]"
          :completion="'🔥 5 missions actives'"
          :cards="pillar3Cards"
        />
      </main>
    </div>
  </div>
</template>

<script>
import HeaderSection from "./HeaderSection.vue"
import SidebarSection from "./SidebarSection.vue"
import LiveChallengeBanner from "./LiveChallengeBanner.vue"
import PillarSection from "./PillarSection.vue"

export default {
  name: "ConsumerDashboard",
  components: {
    HeaderSection,
    SidebarSection,
    LiveChallengeBanner,
    PillarSection,
  },
  data() {
    return {
      user: {
        name: "Léa Martin",
        level: 7,
        avatar: "🌳",
        xp: 1850,
        xpMax: 2500,
        badges: [
          { icon: "🌍", name: "Sauveur Planète", earned: true },
          { icon: "🥕", name: "Expert Local", earned: true },
          { icon: "💪", name: "Macro Master", earned: true },
          { icon: "🔒", name: "Verrouillé", earned: false },
          { icon: "🔒", name: "Verrouillé", earned: false },
          { icon: "🔒", name: "Verrouillé", earned: false },
        ],
      },
      pillarHeaders: [
        {
          icon: "📚",
          title: "Apprentissage Gamifié",
          subtitle: "Modules microlearning et parcours pédagogiques",
        },
        {
          icon: "✅",
          title: "Validation des compétences",
          subtitle: "Enquêtes intelligentes et certifications",
        },
        {
          icon: "🏆",
          title: "Défis Terrain",
          subtitle: "Challenges collectifs et missions sur le terrain",
        },
      ],
      pillar2Cards: [
        {
          title: "Check-In Hebdomadaire",
          description: "Partage ton expérience de la semaine en 30 secondes. Format swipe simple et anonyme.",
          progress: 85,
          points: 20,
          type: "Check-In",
          icon: "📍",
        },
        {
          title: "Enquête Narrative Trimestrielle",
          description: "Crée ton menu idéal pour 10 amis. Tes choix révèlent tes connaissances nutritionnelles !",
          progress: 0,
          points: 100,
          type: "Enquête",
          icon: "🎯",
        },
        {
          title: "NutriPasseport Bronze - Nutrition",
          description: "Tu as obtenu ton premier certificat ! Télécharge-le pour ton portfolio scolaire.",
          progress: 100,
          points: 500,
          type: "Certification",
          icon: "🥉",
        },
      ],
      pillar3Cards: [
        {
          title: "Battle Resto - Novembre",
          description:
            "Ton collège est en 2ème position ! Réduis le gaspillage pour passer 1er et gagner un menu spécial.",
          progress: 72,
          points: 1000,
          type: "Battle",
          icon: "🔴",
        },
        {
          title: "Mission Secrète du Jour",
          description:
            "Photographie un légume local dans ton assiette avec le filtre AR 'Info Produit'. Validation géolocalisée.",
          progress: 0,
          points: 75,
          type: "Mission",
          icon: "📸",
        },
        {
          title: "Semaine Anti-Gaspi",
          description:
            "Scanne ton plateau avant/après chaque repas. L'IA mesure tes progrès et débloque du contenu exclusif !",
          progress: 60,
          points: 400,
          type: "Semaine",
          icon: "⏳",
        },
      ],
      surveyLinks: [],
      surveyLinksCount: null,
      searchTerm: null,
      loading: false,
      page: 1,
      limit: 6,
    }
  },
  computed: {
    pillar1Cards() {
      return this.surveyLinks.map((link) => ({
        title: link.title || (link.survey && link.survey.name) || "",
        description: link.description || (link.survey && link.survey.description) || "",
        points: link.points || 0,
        icon: link.icon || (link.can_answer ? "✅" : "🔒"),
        type: "Quiz",
        progress: link.progress || 0,
      }))
    },
    offset() {
      return (this.page - 1) * this.limit
    },
  },
  methods: {
    fetchSurveyLinks() {
      this.loading = true
      fetch(`/api/v1/studysurveys/?limit=${this.limit}&offset=${this.offset}`)
        .then((res) => res.json())
        .then((data) => {
          this.surveyLinks = data.results || data
          this.surveyLinksCount = this.surveyLinks.length
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    updateRoute(page) {
      this.page = page
      this.fetchSurveyLinks()
    },
    clearSearch() {
      this.searchTerm = ""
      this.fetchSurveyLinks()
    },
    search() {
      this.page = 1
      this.fetchSurveyLinks()
    },
  },
  watch: {
    page() {
      this.fetchSurveyLinks()
    },
  },
  mounted() {
    this.fetchSurveyLinks()
  },
}
</script>

<style scoped>
.consumer-dashboard {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
  padding: 0;
  margin-left: 0px !important;
  margin-right: 0px !important;
  max-width: 100% !important;
  text-align: left !important;
}
.dashboard-grid {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 25px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
}
.main-content {
  display: flex;
  flex-direction: column;
  gap: 25px;
}
</style>
